import React from 'react';
import { Link } from 'react-router-dom';
import './notFoundPage.css';
import Banner from '../Banner/Banner';

const NotFoundPage = () => (
    <>
        <Banner />
        <section className="nf-container">
            <div className="nf-card">
                <h1 className="nf-code">404</h1>
                <h2 className="nf-title">Oops! Page Not Found</h2>
                <p className="nf-text">
                    Sorry, we can’t find the page you’re looking for.
                </p>
                <Link to="/" className="nf-button">
                    Go Back Home
                </Link>
            </div>
        </section>
    </>

);

export default NotFoundPage;
